import { useAuthHydration } from '@/hooks/use-auth-hydration';
import api from '@/services/api';
import { useAuthStore } from '@/store/authStore';
import { Charge } from '@/types/charge';
import { USER_ROLE } from '@/types/user-role';
import { useQuery } from '@tanstack/react-query';
import { chargeKeys } from './use-charges';

const PAGE_SIZE = 100;

/**
 * Todas as cobranças do cliente logado — de contrato E de agendamento avulso.
 * Não derive a lista de `enrollment.charges`: o avulso não tem contrato, e a
 * cobrança dele sumiria da tela do cliente. `serviceName`/`providerName` já
 * chegam resolvidos para as duas origens.
 */
export function useClientCharges() {
  const isHydrated = useAuthHydration();
  const { user } = useAuthStore();
  const isClient = user?.role === USER_ROLE.CLIENT;

  return useQuery({
    queryKey: [...chargeKeys.all, 'client', 'me'],
    queryFn: async () => {
      const all: Charge[] = [];
      for (let page = 1; ; page++) {
        const response = await api.get<{ data: Charge[]; total: number }>('/charge/client/me', {
          params: { page, limit: PAGE_SIZE },
        });
        const { data, total } = response.data;
        all.push(...data);
        if (data.length === 0 || all.length >= total) return all;
      }
    },
    enabled: isHydrated && isClient,
  });
}
